import parentConfig from '@/app-template/lib/config';
import { storefront, cart, home, newspaper, personCircle, calendar,
        cardOutline, businessOutline, notifications, } from 'ionicons/icons';

export default {
  ...parentConfig,
  
  versionCode: '2.0.0',
  websiteUrl: 'https://oceanswimclub.hk/',
  
  primaryColor: '#353190',
  logo: require('@/assets/logo.png'),
  logoWithText: require('@/assets/logo.png'),

  Firebase: {
    apiKey: "AIzaSyAuquahpzMYgto9v9X1TQ94yFHNJg28Ygs",
    authDomain: "onetwogohk.firebaseapp.com",
    projectId: "onetwogohk",
    storageBucket: "onetwogohk.appspot.com",
    messagingSenderId: "419996174247",
    appId: "1:419996174247:web:76cd895f14295c94a91882"
  },

  Stripe: {
    publishableKey: 'pk_test_51HVue8F5eqkgmghRoS3cNn8SMdn9ou9PIffiirbX1a4BvdgPSgCGHWvX6EO4XQF6ppPZdkFxyJHE8MmwGs2aby8P00g5qBbCG0', // test
    //publishableKey: 'pk_live_bgpMcJ1hEX4USgurzqi4oHu4',
  },

  OneSignal: {
    appId: 'e8d50516-0f74-41da-a638-c9d2bb2c6c98',
  },

  HomePage: {
    banner: {
      slidingSpeed: 1000, // Duration of transition between slides (in ms)
      autoPlayDelay: 3000, // Delay between transitions (in ms)
      desktopSlidesPerView: 1,
    }
  },

  authPages: [...parentConfig.authPages],
  memberPages: [...parentConfig.memberPages],
  extraRootRoutes: [], // example: { path: '/login', component: () => import('@/pages/LoginPage.vue') }
  extraTabRoutes: [
    {
      path: 'services',
      component: () => import('@/pages/ServiceListPage.vue')
    },
    {
      path: 'bookings',
      component: () => import('@/pages/BookingPage.vue'),
    },
    {
      path: "bookings/:id",
      name: "BookingDetailPage",
      component: () => import("@/pages/BookingDetailPage.vue"),
      props: true,
    },
    {
      path: 'notifications',
      name: 'NotificationListPage',
      component: () => import('@/pages/NotificationListPage.vue'),
    },
    {
      path: 'notifications/:id',
      name: 'NotificationDetailPage',
      component: () => import("@/pages/NotificationDetailPage.vue"),
      props: true,
    },
  ], // example: { path: 'home', component: () => import('@/pages/HomePage.vue') }

  paymentMethods: [
    { key: "Credit Card", value: "card", icon: cardOutline },
    { key: "Bank Transfer", value: "bank", icon: businessOutline },
  ],
  
  tabs: [
    { icon: storefront, slug: 'products', label: 'shop' },
    { icon: notifications, slug: 'notifications', label: 'notifications'},
    { icon: cart, slug: 'cart', label: 'cart' },
    { icon: home, slug: 'home' },
    { icon: newspaper, slug: 'posts', label: 'forum' },
    { icon: calendar, slug: 'bookings', label: 'bookings'},
    { icon: personCircle, slug: 'profile', label: 'profile' }, 
  ],
}